module.exports = __webpack_public_path__ + "static/img/jchb1-1.18e2d7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-1.png
// module id = 758
// module chunks = 0